import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M14.51 5.316a.75.75 0 0 1-.554-.905l.373-1.551a.75.75 0 1 1 1.459.35l-.373 1.552a.75.75 0 0 1-.905.554M9.052 3.693a.75.75 0 1 0-1.28.784l.835 1.363a.75.75 0 0 0 1.28-.783z" />
    <path
      fillRule="evenodd"
      d="M14.651 16.582a5.232 5.232 0 1 0-6.925-4.32c-1.908.143-3.481 1.511-3.884 3.324a2.7 2.7 0 0 0-1.592 2.458c0 1.507 1.24 2.706 2.742 2.706h6.35c1.87 0 3.408-1.492 3.408-3.361q0-.42-.099-.808m-.697-1.352a3.42 3.42 0 0 0-2.385-1.195 4.32 4.32 0 0 0-2.297-1.613 3.732 3.732 0 1 1 4.682 2.808m-8.698.991c.142-1.376 1.331-2.471 2.8-2.471 1.058 0 1.975.57 2.455 1.407a.75.75 0 0 0 .7.375q.064-.005.13-.005c1.067 0 1.909.846 1.909 1.862 0 1.015-.842 1.861-1.909 1.861h-6.35c-.698 0-1.241-.553-1.241-1.206 0-.556.39-1.037.938-1.17a.75.75 0 0 0 .568-.652"
      clipRule="evenodd"
    />
    <path d="M19.27 13.09a.75.75 0 0 1 .905-.554l1.552.373a.75.75 0 1 1-.35 1.458l-1.552-.373a.75.75 0 0 1-.554-.904M4.63 8.798a.75.75 0 1 0-.35 1.459l1.554.373a.75.75 0 0 0 .35-1.458zM16.37 17.08a.75.75 0 0 1 1.03.248l.834 1.361a.75.75 0 0 1-1.28.783l-.832-1.36a.75.75 0 0 1 .247-1.032M18.749 7.185a.75.75 0 1 0 .783 1.28l1.36-.834a.75.75 0 1 0-.783-1.279z" />
  </>
);

const Weather34 = Icon('weather-34', svgContents);

export default Weather34;
